import React, { useState } from "react";
import { Reveal } from "./Reveal";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
const faqs = [{
  q: "¿Necesito experiencia previa?",
  a: "No. El Kit fue creado para personas que comienzan desde cero."
}, {
  q: "¿Cuándo recibiré el material?",
  a: "Inmediatamente después de completar tu compra."
}, {
  q: "¿Es un pago único?",
  a: "Sí. Pagas una sola vez y el acceso es de por vida."
}, {
  q: "¿Necesito comprar muchos materiales?",
  a: "No. Aprenderás qué necesitas para comenzar sin hacer gastos innecesarios."
}, {
  q: "¿Puedo hacerlo desde casa?",
  a: "Sí. Todo el sistema está pensado para que puedas crear tu primera línea de sales de baño desde casa, paso a paso."
}];
function FaqItem({
  q,
  a
}: {
  q: string;
  a: string;
}) {
  const [open, setOpen] = useState(false);
  return <div className="overflow-hidden rounded-2xl border border-[#e7d3d8] bg-white" data-id="element-48" data-mp="nn8ltwzzwjtf">
      <button onClick={() => setOpen(o => !o)} aria-expanded={open} className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left" data-id="element-49" data-mp="pizdjrtfcud7">
        <span className="text-sm font-bold text-[#3d2b30]" data-id="element-50" data-mp="fk9uvwtpf5vw">{q}</span>
        <ChevronDownIcon className={`h-5 w-5 flex-shrink-0 text-[#a04a63] transition-transform ${open ? "rotate-180" : ""}`} data-id="element-51" data-mp="fm4e96pbupxv" />
      </button>
      <AnimatePresence initial={false} data-id="element-52" data-mp="6pdbyck6meuu">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: "auto",
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25
      }} data-id="element-53" data-mp="bj83u39xy050">
            <p className="px-5 pb-4 text-sm leading-relaxed text-[#6b565b]" data-id="element-54" data-mp="1svdfufg3cqy">{a}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function Faq() {
  return <section className="w-full bg-[#fbf5f0] px-5 py-14" data-id="element-55" data-mp="3nya5wzp5s36j">
      <div className="mx-auto max-w-xl" data-id="element-56" data-mp="1ugkxuc35aamg">
        <Reveal className="text-center" data-id="element-57" data-mp="1uifgtkuuvsnw">
          <h2 className="font-serif-display text-2xl font-semibold text-[#3d2b30] sm:text-3xl" data-id="element-58" data-mp="1pq4j8onl8iyi">
            Preguntas Frecuentes
          </h2>
        </Reveal>
        <div className="mt-8 space-y-3" data-id="element-59" data-mp="1krks89u50gza">
          {faqs.map((f, i) => <Reveal key={f.q} delay={i * 0.04} data-id="element-60" data-mp="1fsztkeuja5cy" data-mpi={i}>
              <FaqItem q={f.q} a={f.a} data-id="element-61" data-mp="1fq3tokz4l6lv" />
            </Reveal>)}
        </div>
        <Reveal delay={0.1} className="mt-10 text-center" data-id="element-62" data-mp="2dexesk0asosl">
          <p className="text-xs text-[#9a7d84]" data-id="element-63" data-mp="28hnjinq89iwu">
            © {new Date().getFullYear()} Kit Lanza tu Línea de Sales de Baño™. Todos los
            derechos reservados.
          </p>
        </Reveal>
      </div>
    </section>;
}